import { interBoldItalicFontFace } from 'utilities/interBoldItalicFontFace.js';
import { unescapeHtml } from 'utilities/core.js';
import { h, render, Component } from 'preact';
import { interBoldItalicFontFamily } from 'utilities/interFontFamily.js';
import TextFoam from './TextFoam.jsx';

class ThumbnailTextOverlay extends Component {
  render() {
    return (
      <div style={this.controlContainerStyles()}>
        <style>{interBoldItalicFontFace}</style>
        <span style={this.linesWrapperStyles()}>{this.renderTextLines()}</span>
      </div>
    );
  }

  renderTextLines() {
    this.textLinesFittedPromises = [];
    const textLineStrings = this.props.text.split('\n');
    return textLineStrings.map((line) => {
      let resolvePromiseForLine;
      const promiseForLine = new Promise((resolve) => {
        resolvePromiseForLine = resolve;
      });
      this.textLinesFittedPromises.push(promiseForLine);
      return (
        <TextFoam
          style={this.textStyles()}
          maxFontSize={this.props.height / 5}
          minFontSize={14}
          maxWidth={this.props.width * 0.8}
          onFitted={resolvePromiseForLine}
        >
          {/* Put a space character on empty lines so customers can use newlines
            to do some intentional positioning of text. If we didn't do this,
            empty lines wouldn't take up any space. */}
          {unescapeHtml(line) || ' '}
        </TextFoam>
      );
    });
  }

  componentDidUpdate() {
    Promise.all(this.textLinesFittedPromises).then(() => {
      this.props.onTextFitted();
    });
  }

  controlContainerStyles() {
    return {
      alignItems: 'start',
      display: 'flex',
      height: this.props.height,
      justifyContent: 'center',
      pointerEvents: 'none',
      position: 'absolute',
      textAlign: 'center',
      width: this.props.width,
    };
  }

  linesWrapperStyles() {
    return {
      alignItems: 'center',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      width: '80%',
      marginTop: '5%',
    };
  }

  textStyles() {
    return {
      color: '#FFFFFF',
      fontFamily: interBoldItalicFontFamily,
      lineHeight: '1.2em',
      textAlign: 'center',
      textShadow: '2px 2px 5px rgba(0,0,0,.4)',
    };
  }
}

export default ThumbnailTextOverlay;
